const provinciasRD = {
  "Azua": [
    "Azua de Compostela", "Estebania", "Guayabal", "Las Charcas", "Las Yayas de Viajama",
    "Padre Las Casas", "Peralta", "Pueblo Viejo", "Sabana Yegua", "Tabara Arriba"
  ],
  "Bahoruco": [
    "Neiba", "Galvan", "Los Rios", "Tamayo", "Villa Jaragua"
  ],
  "Barahona": [
    "Santa Cruz de Barahona", "Cabral", "El Penon", "Enriquillo", "Fundacion",
    "Jaquimeyes", "La Cienaga", "Las Salinas", "Paraiso", "Polo", "Vicente Noble"
  ],
  "Dajabon": [
    "Dajabon", "El Pino", "Loma de Cabrera", "Partido", "Restauracion"
  ],
  "Distrito Nacional": [
    "Santo Domingo de Guzman"
  ],
  "Duarte": [
    "San Francisco de Macoris", "Arenoso", "Castillo", "Eugenio Maria de Hostos",
    "Las Guaranas", "Pimentel", "Villa Riva"
  ],
  "El Seibo": [
    "El Seibo", "Miches"
  ],
  "Elias Pina": [
    "Comendador", "Banica", "El Llano", "Hondo Valle", "Juan Santiago", "Pedro Santana"
  ],
  "Espaillat": [
    "Moca", "Cayetano Germosen", "Gaspar Hernandez", "Jamao al Norte"
  ],
  "Hato Mayor": [
    "Hato Mayor del Rey", "El Valle", "Sabana de la Mar"
  ],
  "Hermanas Mirabal": [
    "Salcedo", "Tenares", "Villa Tapia"
  ],
  "Independencia": [
    "Jimani", "Cristobal", "Duverge", "La Descubierta", "Mella", "Postrer Rio"
  ],
  "La Altagracia": [
    "Higuey", "San Rafael del Yuma"
  ],
  "La Romana": [
    "La Romana", "Guaymate", "Villa Hermosa"
  ],
  "La Vega": [
    "La Vega", "Constanza", "Jarabacoa", "Jima Abajo"
  ],
  "Maria Trinidad Sanchez": [
    "Nagua", "Cabrera", "El Factor", "Rio San Juan"
  ],
  "Monsenor Nouel": [
    "Bonao", "Maimon", "Piedra Blanca"
  ],
  "Monte Cristi": [
    "Monte Cristi", "Castanuelas", "Guayubin", "Las Matas de Santa Cruz",
    "Pepillo Salcedo", "Villa Vasquez"
  ],
  "Monte Plata": [
    "Monte Plata", "Bayaguana", "Peralvillo", "Sabana Grande de Boya", "Yamasa"
  ],
  "Pedernales": [
    "Pedernales", "Oviedo"
  ],
  "Peravia": [
    "Bani", "Nizao"
  ],
  "Puerto Plata": [
    "San Felipe de Puerto Plata", "Altamira", "Guananico", "Imbert",
    "Los Hidalgos", "Luperon", "Sosua", "Villa Isabela", "Villa Montellano"
  ],
  "Samana": [
    "Santa Barbara de Samana", "Las Terrenas", "Sanchez"
  ],
  "San Cristobal": [
    "San Cristobal", "Bajos de Haina", "Cambita Garabitos", "Los Cacaos",
    "Sabana Grande de Palenque", "San Gregorio de Nigua", "Villa Altagracia", "Yaguate"
  ],
  "San Jose de Ocoa": [
    "San Jose de Ocoa", "Rancho Arriba", "Sabana Larga"
  ],
  "San Juan": [
    "San Juan de la Maguana", "Bohechio", "El Cercado", "Juan de Herrera",
    "Las Matas de Farfan", "Vallejuelo"
  ],
  "San Pedro de Macoris": [
    "San Pedro de Macoris", "Consuelo", "Guayacanes", "Quisqueya",
    "Ramon Santana", "San Jose de Los Llanos"
  ],
  "Sanchez Ramirez": [
    "Cotui", "Cevicos", "Fantino", "La Mata"
  ],
  "Santiago": [
    "Santiago de los Caballeros", "Bisono", "Janico", "Licey al Medio",
    "Punal", "Sabana Iglesia", "San Jose de las Matas",
    "Tamboril", "Villa Gonzalez"
  ],
  "Santiago Rodriguez": [
    "San Ignacio de Sabaneta", "Moncion", "Villa Los Almacigos"
  ],
  "Santo Domingo": [
    "Santo Domingo Este", "Santo Domingo Norte", "Santo Domingo Oeste",
    "Boca Chica", "Los Alcarrizos", "Pedro Brand", "San Antonio de Guerra"
  ],
  "Valverde": [
    "Mao", "Esperanza", "Laguna Salada"
  ]
};

export default provinciasRD;
